import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { useTranslation } from 'react-i18next';

import img1 from '../assets/images/about/about.jpg';

function AppAbout() {
  const { t } = useTranslation();

  return (
    <section id="about" className="block about-block">
      <Container fluid>
        <div className="title-holder">
          <h2>{t('aboutTitle')}</h2>
          <div className="subtitle">{t('aboutDesc')}</div>
        </div>
        <Row>
          <Col sm={6}>
            <Image src={img1} />
          </Col>
          <Col sm={6}>
            <p>{t('aboutContent')}</p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default AppAbout;
